module.exports = __webpack_public_path__ + "img/Bell green.dd91fff4.svg";